module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_menu_pomodoro.cd2ebfd0.svg";